import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { Typography, Stack } from '@mui/material';
import { defaultValueFormatter } from 'components/data-card/data-card.utils';
import { useTranslation } from 'react-i18next';

export type PreviousPeriodDataCardDescriptionProps = {
  previousPeriodPercent: number;
  invertColor?: boolean;
  numberFormatOptions?: Intl.NumberFormatOptions;
};

const PreviousPeriodDataCardDescription = ({
  previousPeriodPercent,
  invertColor = false,
  numberFormatOptions,
}: PreviousPeriodDataCardDescriptionProps) => {
  const { t } = useTranslation();

  if (previousPeriodPercent === null) {
    return null;
  }
  const isSuccess = previousPeriodPercent >= 0;
  const isSuccessColor = invertColor ? !isSuccess : isSuccess;

  return (
    <Typography
      variant="body2"
      component="div"
      color={isSuccessColor ? 'success.main' : 'error.main'}
    >
      <Stack direction="row" spacing={0.5} alignItems="center">
        {isSuccess ? (
          <ArrowUpward data-testid="ComparisonIndicator.ArrowUpwardIcon" />
        ) : (
          <ArrowDownward data-testid="ComparisonIndicator.ArrowDownwardIcon" />
        )}
        <Typography variant="body2">
          {t('PreviousPeriodDataCard.vs', {
            percentage: defaultValueFormatter(
              previousPeriodPercent,
              'percent',
              { numberFormatOptions },
            ),
          })}
        </Typography>
      </Stack>
    </Typography>
  );
};

export default PreviousPeriodDataCardDescription;
